import MultipleRoute from './MultipleRoute';
export default MultipleRoute;
